import React, { FC } from 'react';
import { Box, Button, Card, CardContent } from '@mui/material';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import { currentUserVar } from 'apollo/reactive-variables/user';
import { permissions } from 'utils/permission';
import PageTitle from 'components/shared/page-title/page-title.component';
import { EditLabProvider } from '../../../context/edit-lab-context';
import LabInfo from 'components/manage-labs/edit-lab/lab-info.component';
import ActiveActionSet from 'components/manage-labs/edit-lab/active-action-set.component';
import MaterialGroups from 'components/manage-labs/edit-lab/material-groups/material-groups.component';
import PriceList from 'components/manage-labs/edit-lab/price-list/price-list.component';

const EditLabContent: FC = () => {
    const { labId } = useParams<{ labId: string }>();
    const { t: translate } = useTranslation(['common', 'organization', 'price-requests']);
    const currentUser = useReactiveVar(currentUserVar);
    return (
        <Box>
            <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                <PageTitle headingStyle="h1" title={translate('organization:EDIT_LAB')} />
                {/* DD-3697: this lab's price requests; same audience as the menu entry. */}
                {permissions.isDentistAdmin(currentUser?.role) ? (
                    <Button
                        component={RouterLink}
                        to={`/price-requests?counterpart=${labId}`}
                        startIcon={<RequestQuoteOutlinedIcon />}
                        data-test="edit-lab.price-requests"
                    >
                        {translate('price-requests:PRICE_REQUESTS')}
                    </Button>
                ) : undefined}
            </Box>
            <Card sx={{ boxShadow: 3 }}>
                <CardContent sx={{ p: 3 }}>
                    <LabInfo />
                    <ActiveActionSet />
                    <MaterialGroups />
                    <PriceList />
                </CardContent>
            </Card>
        </Box>
    );
};

const EditLab: FC = () => {
    const { labId } = useParams<{ labId: string }>();
    return (
        <EditLabProvider labId={labId!}>
            <EditLabContent />
        </EditLabProvider>
    );
};

export default EditLab;
